//src/theme/breakpoints.ts
export const breakpoints = {
    mobile: '780px',
    tablet: '1068px',
    desktop: '1224px',
  };
  